import SiteLayout from "../components/site/SiteLayout";

function Contact() {
  const handleSubmit = (event) => event.preventDefault();

  return (
    <SiteLayout>
      <section className="page-hero">
        <div className="container">
          <h1>Contact Us</h1>
          <p>
            We would love to hear from you. Reach out for partnerships, volunteering, or campaign
            collaborations.
          </p>
        </div>
      </section>
      <section className="section">
        <div className="container split-grid">
          <form className="form-card" onSubmit={handleSubmit}>
            <h3>Send a message</h3>
            <div className="form-grid">
              <label>
                Full Name
                <input type="text" name="name" placeholder="Ananya Sharma" required />
              </label>
              <label>
                Email Address
                <input type="email" name="email" placeholder="ananya@company.org" required />
              </label>
              <label>
                Subject
                <input type="text" name="subject" placeholder="Partnership inquiry" required />
              </label>
              <label>
                Message
                <textarea name="message" rows="4" placeholder="Share your goals and ideas." required />
              </label>
              <button className="btn btn-primary" type="submit">
                Submit Message
              </button>
            </div>
          </form>
          <div className="form-card">
            <h3>Visit our office</h3>
            <p>12 Park Avenue, New Delhi, India</p>
            <p>Phone: +91 98 7000 2200</p>
            <p>Email: hello@hopefoundation.org</p>
            <div className="card" style={{ marginTop: "18px" }}>
              <strong>Office Hours</strong>
              <p>Monday - Saturday: 9:00 AM to 6:00 PM</p>
              <p>Sunday: Community outreach only</p>
            </div>
          </div>
        </div>
      </section>
    </SiteLayout>
  );
}

export default Contact;
